module.exports = __webpack_public_path__ + "static/media/home_title.3751d122.png";